module.exports = __webpack_public_path__ + "static/58-historian-may2045-e8d1a2870a4337794c4ea9650f182dfa.jpg";